import { Injectable, inject } from '@angular/core';
import { ContactReferenceService } from 'src/app/contact-reference.service';
import { UserService } from './user.service';

@Injectable( {
	providedIn: 'root'
} )
export class DocsWhitelistService {
	private userService = inject( UserService );
	private contactRefService = inject( ContactReferenceService );
	private whitelistByClient = new Map<string, string[]>();

	public whitelist: string[];

	async getWhitelistByUser (): Promise<string[]> {
		const user = await this.userService.getUser();
		if ( !user?.client ) return [];

		const clientId = user.client;
		if ( !this.whitelistByClient.has( clientId ) ) {
			const list = await this.getWhitelist( clientId );
			this.whitelistByClient.set( clientId, list );
		}
		return this.whitelistByClient.get( clientId ) ?? [];
	}

	async getWhitelist ( clientId: string ): Promise<string[]> {
		const list = await this.contactRefService.getContactReferenceByReference( 'client', clientId );
		return list
			.filter( li => li.function === 'cdc' )
			.map( li => li.contact );
	}
}
